import { render } from "./channelDialog.vue?vue&type=template&id=2833d11d&scoped=true"
import script from "./channelDialog.vue?vue&type=script&lang=js"
export * from "./channelDialog.vue?vue&type=script&lang=js"

import "./channelDialog.vue?vue&type=style&index=0&id=2833d11d&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2833d11d"]])

export default __exports__